import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useRouter } from "vue-router/composables";

import VignetteLogo from "@/components/AlmanacPlusLogo.vue";
import { VignetteRoutes } from "@/types";
import { useSessionStore } from "@/pinia/session";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerError',
  setup(__props) {

const sessionStore = useSessionStore();
const hasVignetteAccess = computed(
  () => sessionStore.hasVignetteAccess ?? false
);
const router = useRouter();

const getHomePath = () => router.resolve({ name: VignetteRoutes.Home }).href;
const getSearchPath = () =>
  router.resolve({ name: VignetteRoutes.SearchCongressional }).href;

return { __sfc: true,sessionStore, hasVignetteAccess, router, getHomePath, getSearchPath, VignetteLogo }
}

})